import React from "react";
import CustomTimeSheetTable from "../../../components/CustomTimeSheetTable";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
// import { getCookieData } from "../../../helper/api";
interface ReviewTimesheetReportProps {
  onClose?: () => void;
  hideHomeButton?: boolean;
  memberID?: number | null;
  dateState?: string;
  role?: string;
  employeeNameData?: string;
  employeeIDDatas?: string;
}
const ReviewApproveTimesheet: React.FC<ReviewTimesheetReportProps> = ({
  onClose,
  hideHomeButton = false,
  memberID,
  dateState,
  role,
  employeeNameData,
  employeeIDDatas,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  // const query = getCookieData("timesheetsReport");
  const state = location.state as
    | {
        id: string | null;
        memberID: number;
        dateState: string;
        role: string;
        employeeNameData: string;
        employeeIDData: string;
      }
    | undefined; // Assuming state is an object with an 'id' property
  // const cookeei = query ? JSON.parse(query) : null;
  // const date = cookeei?.id ? cookeei?.id.split("-") : null;

  const MemberID = memberID ? memberID : state?.memberID
  const routeState = dateState
    ? dateState.split("-")
    : state?.id
    ? state?.id.split("-")
    : null;
  const startdate = routeState ? moment(routeState[0]).toDate() : null;
  const enddate = routeState ? moment(routeState[1]).toDate() : null;

  // console.log(memberID, startdate, enddate, employeeNameData, employeeIDDatas, state);

  console.log('review 1 startdate, enddate', startdate, enddate)
  console.log('review 1 MemberID', MemberID)

  if (!startdate || !enddate) {
    navigate(-1);
    toast.error("Timesheet record has missing start and end date");
  }

  return startdate && enddate ? (
    <>
      {(role === "admin" || state?.role === "admin") && (
        <button
          onClick={() => (onClose ? onClose() : window.close())}
          className="flex  items-center px-4 py-2 mb-4 text-sm bg-red-700 hover:bg-red-800 text-white rounded-lg focus:outline-none "
        >
          Go Back
        </button>
      )}
      <CustomTimeSheetTable
        memberID={MemberID}
        previewFlag={false}
        startDate={startdate}
        endDate={enddate}
        showHomeButton={!hideHomeButton}
        employeeNameData={employeeNameData ?? state?.employeeNameData}
        employeeIDData={employeeIDDatas ? Number(employeeIDDatas) : null}
        reportType="approvereject"
        showapproveReject={true}
        userRoleType={role ?? state?.role ?? "manager"}
        modelClose={onClose}
      />
    </>
  ) : (
    <div>Record not found</div>
  );
};

export default ReviewApproveTimesheet;
